import React from "react";
import DataGridComponent from "Utils/Constants/DataGridComponent";
import { homeList } from "Utils/Helpers/TableColumns";

export default function TableHomeData({ data }) {
  return <DataGridComponent data={data} columns={homeList} />;
}
